<template>
    <div >
        <div class="block">
            <el-timeline>
                <el-timeline-item timestamp="2025/1/9" placement="top">
                    <el-card>
                        <h1>更新仓储平台 任务下发</h1>
                        <p>表格内数据可双击复制</p>
                        <img src="../assets/images/log/dbclick.png" alt="">
                    </el-card>
                </el-timeline-item>
                <!-- <el-timeline-item timestamp="2018/4/3" placement="top">
                    <el-card>
                        <h4>更新 Github 模板</h4>
                        <p>王小虎 提交于 2018/4/3 20:46</p>
                    </el-card>
                </el-timeline-item>
                <el-timeline-item timestamp="2018/4/2" placement="top">
                    <el-card>
                        <h4>更新 Github 模板</h4>
                        <p>王小虎 提交于 2018/4/2 20:46</p>
                    </el-card>
                </el-timeline-item> -->
            </el-timeline>
        </div>
        <!-- <a href="http://www.festlogistics.com/" target="_blank" style="font-size: 30px;">欢迎来到菲尔斯特！</a>
        <input type="text"> -->
        <!-- <div ref="mains" style="width: 100%;height: 300px;background-color: azure; align-items: center;"></div>
        <div ref="mains" style="width: 100%;height: 300px;background-color: azure; align-items: center;"></div>
        <div ref="mains" style="width: 100%;height: 250px;background-color: azure; align-items: center;"></div> -->
    </div>
</template>
<script>
let data = [["2000-06-05", 116], ["2000-06-06", 129],
["2000-06-07", 135], ["2000-06-08", 86], ["2000-06-09", 73],
["2000-06-10", 85], ["2000-06-11", 73], ["2000-06-12", 68],
["2000-06-13", 92], ["2000-06-14", 130], ["2000-06-15", 245],
["2000-06-16", 139], ["2000-06-17", 115], ["2000-06-18", 111],
["2000-06-19", 309], ["2000-06-20", 206], ["2000-06-21", 137],
["2000-06-22", 128], ["2000-06-23", 85], ["2000-06-24", 94],
["2000-06-25", 71]]
const dateList = data.map(function (item) {
    return item[0];
});
const valueList = data.map(function (item) {
    return item[1];
});
export default {
    //组件创建
    created() {
    },
    mounted() {
        // this.initEcharts()
    },
    data() {
        return {
            chartInstance: null,
        }
    },
    methods: {
        dateList(data) {
            data.map(function (item) {
                return item[0];
            })
        },
        valueList(data) {
            data.map(function (item) {
                return item[1];
            });
        },
        initEcharts() {
            this.chartInstance = this.$echarts.init(this.$refs.mains);
            const option = {
                // Make gradient line here
                visualMap: [
                    {
                        show: false,
                        type: 'continuous',
                        seriesIndex: 0,
                        min: 0,
                        max: 400
                    },
                    {
                        show: false,
                        type: 'continuous',
                        seriesIndex: 1,
                        dimension: 0,
                        min: 0,
                        max: dateList.length - 1
                    }
                ],
                title: [
                    {
                        left: 'center',
                        text: '可视化图'
                    },
                ],
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: [

                    {
                        data: dateList,
                        gridIndex: 0
                    }
                ],
                yAxis: [
                    {
                        gridIndex: 0
                    }
                ],
                grid: [
                    {
                        top: '10%'
                    }
                ],
                series: [
                    {
                        type: 'line',
                        showSymbol: false,
                        data: valueList
                    },

                ]
            };
            this.chartInstance.setOption(option)
        }

    }
}
</script>
<style lang="less" scoped>
a {
    font-size: 16px
}

a:link {
    color: blue;
    text-decoration: none;
}

//未访问：蓝色、无下划线 
a:active {
    color: red;
}

//激活：红色 
a:visited {
    color: purple;
    text-decoration: none;
}

//已访问：紫色、无下划线 
a:hover {
    color: red;
    text-decoration: underline;
}

//鼠标移近：红色、下划线</style>